<template>
    <v-container>
        <!--<v-row>-->
            <!--<div class="d-flex d-sm-none">XS</div>-->
            <!--<div class="d-none d-sm-flex d-md-none">SM</div>-->
            <!--<div class="d-none d-md-flex d-lg-none">MD</div>-->
            <!--<div class="d-none d-lg-flex d-xl-none">LG</div>-->
            <!--<div class="d-none d-xl-flex">XL</div>-->
        <!--</v-row>-->
        <v-row v-if="loading" align="center"
               justify="center">

            <v-col
                    cols="12"
            >
                <v-text-field color="grey" loading disabled></v-text-field>
            </v-col>
        </v-row>
        <v-row v-else-if="tpl == 'product'">
            <v-col cols="12">
            </v-col>
            <!-- mobile -->
            <v-col cols="12" v-if="$vuetify.breakpoint.smAndDown">
                <h1 class="font-weight-bold display-1 text-center">{{ page.name }}</h1>
                <div>
                    <v-carousel :show-arrows="false" height="350">
                        <v-carousel-item
                                v-for="(img,i) in page.images"
                                :key="i"
                                :src="cdnUrl+'/products/'+img.src"
                                reverse-transition="fade-transition"
                                transition="fade-transition"
                        ></v-carousel-item>
                    </v-carousel>
                </div>
                <p class="font-weight-medium display-1 accent--text text-center mt-5" v-if="page.consulta == 0">${{ price | number_format_real}}</p>
                <div v-if="page.consulta == 1">
                    Check availability at <a href="mailto:orders@ppshealthcare.com">orders@ppshealthcare.com</a>
                    <br>
                </div>
                <div v-else-if="page.in_stock == 1">
                    <strong>In Stock</strong>
                </div>
                <div v-else>
                    <strong>Out of stock</strong>
                </div>
                <div>
                    <strong>Product Code</strong>
                    : {{sku}}
                </div>
            </v-col>
            <!-- desktop -->
            <!--images-->
            <v-col cols="4" v-if="$vuetify.breakpoint.mdAndUp">
                <v-row>
                    <v-col cols="3" xl="2" lg="3" md="3">
                        <v-container fluid v-if="page.images">
                            <v-row>
                                <v-col
                                        v-for="(image,index) in images"
                                        :key="index"
                                        class="d-flex child-flex"
                                        cols="12"
                                >
                                    <v-card flat outlined :hover="true" class="d-flex">
                                        <v-img
                                                :src="cdnUrl+'/products/'+image.src"
                                                :lazy-src="cdnUrl+'/products/'+image.src"
                                                class="grey lighten-2"
                                                @click="changeImage(cdnUrl+'/products/'+image.src)"
                                        >
                                            <template v-slot:placeholder>
                                                <v-row
                                                        class="fill-height ma-0"
                                                        align="center"
                                                        justify="center"
                                                >
                                                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                                </v-row>
                                            </template>
                                        </v-img>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-col>
                    <v-col cols="10" xl="10" lg="9" md="9">
                        <v-img
                                v-if="images"
                                :src="imgDefault"
                                :lazy-src="imgDefault"
                                aspect-ratio="1"
                                class="grey lighten-2"
                        >
                        </v-img>
                    </v-col>
                </v-row>
            </v-col>
            <!--details-->
            <v-col cols="6" v-if="$vuetify.breakpoint.mdAndUp">
                <h1 class="font-weight-bold display-1">{{ page.name }}</h1>
                <p class="subtitle-2" v-html="page.short_description"></p>
                <p class="font-weight-medium display-1 accent--text" v-if="page.consulta == 0">${{ price | number_format_real}}</p>
                <div v-if="page.type == 'variable' && page.consulta == 0" >
                    <v-select
                            v-if="page.first[1]"
                            :items="page.attribute1_values"
                            :label="page.attribute1_name"
                            v-model="page.first[1]"
                            @change="changeVariable(1)"
                    ></v-select>
                    <v-select
                            v-if="page.first[2]"
                            :items="page.attribute2_values"
                            :label="page.attribute2_name"
                            v-model="page.first[2]"
                            @change="changeVariable(2)"
                    ></v-select>
                    <v-select
                            v-if="page.first[3]"
                            :items="page.attribute3_values"
                            :label="page.attribute3_name"
                            v-model="page.first[3]"
                            @change="changeVariable(3)"
                    ></v-select>
                    <v-select
                            v-if="page.first[4]"
                            :items="page.attribute4_values"
                            :label="page.attribute4_name"
                            v-model="page.first[4]"
                            @change="changeVariable(4)"
                    ></v-select>
                    <v-select
                            v-if="page.first[5]"
                            :items="page.attribute5_values"
                            :label="page.attribute5_name"
                            v-model="page.first[5]"
                            @change="changeVariable(5)"
                    ></v-select>
                </div>
            </v-col>
            <!--button-->
            <v-col cols="2" v-if="$vuetify.breakpoint.mdAndUp">
                <v-card outlined>
                    <v-card-text v-if="page.consulta == 0">
                        <p class="font-weight-medium display-1 accent--text">${{ price | number_format_real}}</p>
                        <div v-if="page.in_stock == 1">
                            <strong>In Stock</strong>
                        </div>
                        <div v-else>
                            <strong>Out of stock</strong>
                        </div>
                        <div>
                            <strong>Product Code</strong>: {{sku}}
                        </div>
                        <v-col cols="12" v-if="page.in_stock == 1">
                            <v-select
                                    :items="quanty"
                                    label="Quantity"
                                    v-model="qty"
                            ></v-select>
                        </v-col>
                        <div class="row mb-8 row--dense" v-if="page.in_stock == 1">
                            <v-col cols="12">
                                <v-btn
                                        v-if="page.type == 'simple'"
                                        type="button"
                                        :loading="load.addCart"
                                        class="mb-6 mb-md-0 v-btn v-btn--contained theme--light v-size--x-large text-none orange"
                                        @click="addProductCart(page.id)"
                                >
                                    <span>Add To Cart</span>
                                </v-btn>
                                <v-btn
                                        v-else
                                        type="button"
                                        :loading="load.addCart"
                                        class="mb-6 mb-md-0 v-btn v-btn--contained theme--light v-size--x-large text-none orange"
                                        @click="addProductCart(product)"
                                >
                                    <span>Add To Cart</span>
                                </v-btn>
                            </v-col>
                        </div>
                    </v-card-text>
                    <v-card-text v-else>
                        <div>
                            <strong>Product Code</strong>: {{sku}}
                        </div>
                        <div>
                            Check availability at <a href="mailto:orders@ppshealthcare.com">orders@ppshealthcare.com</a>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
            <!--descriptions-->
            <v-col cols="12">
                <p class="font-weight-medium headline text-center">Product Description</p>
                <hr>
                <div v-html="descriptions"></div>
            </v-col>
            <!--related-->
            <v-col cols="12">
                <p class="font-weight-bold mb-6 text-center display-2" >You Might Also Like</p>
                <hr>
                <v-row>
                    <v-col
                            cols="6"
                            lg="3"
                            md="3"
                            sm="6"
                            xs="6"
                            v-for="(product,index) in products"
                            :key="index"

                    >
                        <v-card
                                class="mx-auto"
                                :hover="true"
                                :to="'/'+product.meta_url"
                        >
                            <!--no images-->
                            <v-img
                                    v-if="!(product.images) && $vuetify.breakpoint.smAndUp"
                                    class="white--text align-end"
                                    height="400"
                                    max-height="420"
                                    min-height="170"
                                    :src="cdnUrl+'/products/no-img.jpg'"
                                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                            >
                                <v-card-title>{{ product.name }}</v-card-title>
                            </v-img>
                            <v-img
                                    v-else-if="!(product.images) && $vuetify.breakpoint.xsOnly"
                                    class="white--text align-end"
                                    height="210"
                                    max-height="420"
                                    min-height="170"
                                    :src="cdnUrl+'/products/no-img.jpg'"
                                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                            >
                                <v-card-title style="word-break: break-word;">{{ product.name }}</v-card-title>
                            </v-img>
                            <!--images-->
                            <v-img
                                    v-else-if="product.images && product.in_stock && $vuetify.breakpoint.smAndUp"
                                    class="white--text align-end"
                                    height="400"
                                    max-height="420"
                                    min-height="170"
                                    :src="cdnUrl+'/products/'+product.images[0].src"
                                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                            >
                                <v-card-title style="word-break: break-word;">{{ product.name }}</v-card-title>
                            </v-img>
                            <v-img
                                    v-else-if="product.images && product.in_stock == 0 && $vuetify.breakpoint.smAndUp"
                                    class="white--text align-end"
                                    height="400"
                                    max-height="420"
                                    min-height="170"
                                    :src="cdnUrl+'/products/'+product.images[0].src"
                                    gradient="to bottom, rgba(0,0,0,.5), rgba(0,0,0,.8)"
                            >
                                <v-card-title style="word-break: break-word;">{{ product.name }}</v-card-title>
                            </v-img>
                            <v-img
                                    v-else-if="product.images && product.in_stock && $vuetify.breakpoint.xsOnly"
                                    class="white--text align-end"
                                    height="210"
                                    max-height="420"
                                    min-height="170"
                                    :src="cdnUrl+'/products/'+product.images[0].src"
                                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                            >
                                <v-card-title style="word-break: break-word;">{{ product.name }}</v-card-title>
                            </v-img>
                            <v-img
                                    v-else-if="product.images && product.in_stock == 0 && $vuetify.breakpoint.xsOnly"
                                    class="white--text align-end"
                                    height="210"
                                    max-height="420"
                                    min-height="170"
                                    :src="cdnUrl+'/products/'+product.images[0].src"
                                    gradient="to bottom, rgba(0,0,0,.5), rgba(0,0,0,.8)"
                            >
                                <v-card-title style="word-break: break-word;">{{ product.name }}</v-card-title>
                            </v-img>
                            <v-card-text class="text--primary d-none d-lg-flex" style="height: 125px">
                                <div style="overflow:hidden;display: -webkit-box;-webkit-line-clamp: 4;-webkit-box-orient: vertical;" v-html="product.short_description"></div>
                            </v-card-text>
                            <v-card-actions >
                                <v-btn
                                        v-if="product.consulta == 0"
                                        class="title"
                                        color="green"
                                        text

                                >
                                    <span v-if="product.type == 'simple' ">${{ product.regular_price | number_format_real }}</span>
                                    <span v-else-if="product.range_price.min == product.range_price.max">${{ product.range_price.min | number_format_real }}</span>
                                    <span v-else>
                                         ${{ product.range_price.min | number_format_real }}
                                    </span>
                                </v-btn>
                                <v-btn
                                        v-else
                                        small
                                        color="red"
                                        style="color: #0d47a1;"
                                        text
                                        outlined
                                >
                                    On request
                                </v-btn>
                                <v-btn
                                        v-if="product.in_stock"
                                        color="orange"
                                        icon
                                        class="display-4"
                                        x-large
                                >
                                    <v-icon>mdi-cart</v-icon>
                                </v-btn>
                                <v-btn
                                        v-else-if="$vuetify.breakpoint.xsOnly"
                                        color="red"
                                        style="color: #0d47a1;"
                                        icon
                                >

                                    <v-img src="../assets/img/not_avaliable.png" width="40px" ></v-img>
                                </v-btn>
                                <v-btn
                                        v-else
                                        color="red"
                                        style="color: #0d47a1;"
                                        text
                                        outlined
                                >
                                    NOT AVALIABLE
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
            <v-btn @click="addProductCart(page.id)" :loading="load.addCart" type="button" class="v-btn v-size--x-large text-none orange" style="position: fixed;bottom: 0;width: 100%;z-index: 999;" v-if="$vuetify.breakpoint.smAndDown && page.in_stock == 1 && page.consulta == 0">
                <span>Add To Cart</span>
            </v-btn>
        </v-row>
        <v-row v-else-if="tpl == 'brand'">
            <v-col
                    cols="12"
            >
                <h1 class="font-weight-bold display-1 text-center ">{{ page.name }}</h1>
                <hr>
                <v-row>
                    <v-col cols="12" md="3" v-if="$vuetify.breakpoint.mdAndUp">
                        <v-list>
                            <v-subheader>Categories</v-subheader>
                            <v-list-item-group color="cyan">
                                <v-list-item v-for="(item, i) in categoriesList" :key="i" :to="'/'+item.meta_url">
                                    <v-list-item-content>
                                        <v-list-item-title>{{ item.name }}</v-list-item-title>
                                        <v-list v-if="item.sub">
                                            <v-list-item-group color="cyan">
                                                <v-list-item v-for="(subs, j) in item.sub" :key="j" :to="'/'+subs.meta_url">
                                                    <v-list-item-content>
                                                        <v-list-item-title>{{ subs.name }}</v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-list-item-group>
                                        </v-list>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </v-col>
                    <v-col cols="12" md="9">
                        <v-row v-if="page.name == 'Trio Silicone Ostomy Accessories'">
                            <v-col cols="12">
                                <a href="https://trioostomycare.us/product/sample-siltac-silicone-ostomy-seal-1-small/">
                                    <v-img src="../assets/img/trio-page-1-siltac.jpg" width="100%"></v-img>
                                </a>
                            </v-col>
                            <v-col cols="12">
                                <a href="https://trioostomycare.us/product/sample-silex-silicone-flange-extender/">
                                    <v-img src="../assets/img/trio-page-2-silex.jpg" width="100%"></v-img>
                                </a>
                            </v-col>
                            <v-col cols="12">
                                <a href="https://trioostomycare.us/product/sample-silvex-convex-silicone-cohesive-seal-1-size-20mm-30mm/">
                                    <v-img src="../assets/img/trio-page-3-silvex.jpg" width="100%"></v-img>
                                </a>
                            </v-col
                            ><v-col cols="12">
                                <a href="https://trioostomycare.us/product/sample-silken-silicone-stoma-gel/">
                                    <v-img src="../assets/img/trio-page-4-silken.jpg" width="100%"></v-img>
                                </a>
                            </v-col>
                            <v-col cols="12">
                                <a href="https://trioostomycare.us/product/sample-elite-sting-free-adhesive-remover-wipes/">
                                    <v-img src="../assets/img/trio-page-5-elite.jpg" width="100%"></v-img>
                                </a>
                            </v-col>
                            <v-col cols="12">
                                <a href="https://trioostomycare.us/product/sample-trio-pearls-gelling-odor-control-sachets-5-sachets/">
                                    <v-img src="../assets/img/trio-page-6-pearls.jpg" width="100%"></v-img>
                                </a>
                            </v-col>
                            <v-col cols="12">
                                <a href="https://trioostomycare.us/product/sample-elisse-sting-free-skin-barrier-wipes/">
                                    <v-img src="../assets/img/trio-page-7-elisse.jpg" width="100%"></v-img>
                                </a>
                            </v-col>
                        </v-row>
                        <v-row v-else-if="page.name == 'Ostomy ' ">
                            <v-col cols="12">
                                <p class="font-weight-bold display-1">This page is being updated</p>
                            </v-col>
                        </v-row>
                        <v-row v-else>
                            <v-col
                                    cols="6"
                                    lg="3"
                                    md="3"
                                    sm="6"
                                    xs="6"
                                    v-for="(product,index) in page.products"
                                    :key="index"

                            >
                                <v-card
                                        class="mx-auto"
                                        :hover="true"
                                        :to="'/'+product.meta_url"
                                >
                                    <!--no images-->
                                    <v-img
                                            v-if="!(product.images) && $vuetify.breakpoint.smAndUp"
                                            class="white--text align-end"
                                            height="400"
                                            max-height="420"
                                            min-height="170"
                                            :src="cdnUrl+'/products/no-img.jpg'"
                                            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                                    >
                                        <v-card-title style="word-break: break-word;">{{ product.name }}</v-card-title>
                                    </v-img>
                                    <v-img
                                            v-else-if="!(product.images) && $vuetify.breakpoint.xsOnly"
                                            class="white--text align-end"
                                            height="210"
                                            max-height="420"
                                            min-height="170"
                                            :src="cdnUrl+'/products/no-img.jpg'"
                                            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                                    >
                                        <v-card-title style="word-break: break-word;">{{ product.name }}</v-card-title>
                                    </v-img>
                                    <!--images-->
                                    <v-img
                                            v-else-if="product.images && product.in_stock && $vuetify.breakpoint.smAndUp"
                                            class="white--text align-end"
                                            height="300"
                                            max-height="420"
                                            min-height="170"
                                            :src="cdnUrl+'/products/'+product.images[0].src"
                                            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                                    >
                                        <v-card-title style="word-break: break-word;">{{ product.name }}</v-card-title>
                                    </v-img>
                                    <v-img
                                            v-else-if="product.images && product.in_stock == 0 && $vuetify.breakpoint.smAndUp"
                                            class="white--text align-end"
                                            height="300"
                                            max-height="420"
                                            min-height="170"
                                            :src="cdnUrl+'/products/'+product.images[0].src"
                                            gradient="to bottom, rgba(0,0,0,.5), rgba(0,0,0,.8)"
                                    >
                                        <v-card-title style="word-break: break-word;">{{ product.name }}</v-card-title>
                                    </v-img>
                                    <v-img
                                            v-else-if="product.images && product.in_stock && $vuetify.breakpoint.xsOnly"
                                            class="white--text align-end"
                                            height="170"
                                            max-height="420"
                                            min-height="170"
                                            :src="cdnUrl+'/products/'+product.images[0].src"
                                            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                                    >
                                        <v-card-title style="word-break: break-word;">{{ product.name }}</v-card-title>
                                    </v-img>
                                    <v-img
                                            v-else-if="product.images && product.in_stock == 0 && $vuetify.breakpoint.xsOnly"
                                            class="white--text align-end"
                                            height="170"
                                            max-height="420"
                                            min-height="170"
                                            :src="cdnUrl+'/products/'+product.images[0].src"
                                            gradient="to bottom, rgba(0,0,0,.5), rgba(0,0,0,.8)"
                                    >
                                        <v-card-title >{{ product.name }}</v-card-title>
                                    </v-img>
                                    <v-card-text class="text--primary d-none d-lg-flex" style="height: 125px">
                                        <div style="overflow:hidden;display: -webkit-box;-webkit-line-clamp: 4;-webkit-box-orient: vertical;" v-html="product.short_description"></div>
                                    </v-card-text>
                                    <v-card-actions >
                                        <v-btn  v-if="product.consulta == 0"
                                                class="title"
                                                color="green"
                                                text

                                        >
                                            <span v-if="product.type == 'simple' ">${{ product.regular_price | number_format_real }}</span>
                                            <span v-else-if="product.range_price.min == product.range_price.max">${{ product.range_price.min | number_format_real }}</span>
                                            <span v-else>
                                                 ${{ product.range_price.min | number_format_real }}
                                            </span>
                                        </v-btn>
                                        <v-btn
                                                v-else
                                                small
                                                color="red"
                                                style="color: #0d47a1;"
                                                text
                                                outlined
                                        >
                                            On request
                                        </v-btn>
                                        <v-btn
                                                v-if="product.in_stock"
                                                color="orange"
                                                icon
                                                class="display-4"
                                                x-large
                                        >
                                            <v-icon>mdi-cart</v-icon>
                                        </v-btn>
                                        <v-btn
                                                v-else-if="$vuetify.breakpoint.xsOnly"
                                                color="red"
                                                style="color: #0d47a1;"
                                                icon
                                        >

                                            <v-img src="../assets/img/not_avaliable.png" width="40px" ></v-img>
                                        </v-btn>
                                        <v-btn
                                                v-else
                                                color="red"
                                                style="color: #0d47a1;"
                                                text
                                                outlined
                                        >
                                            NOT AVALIABLE
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row v-else>
            <v-col cols="12">
                <h1 class="font-weight-bold display-1 text-center">Page not found</h1>
                <v-btn color="success" :to="'/'">
                    <v-icon left>
                    mdi-arrow-left-bold
                    </v-icon>
                    Back to home</v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    export default {
        props: {
            cartVisible: { type: Boolean },
            categoriesList:{ type: Object},
            appUrl: { type: String },
            cdnUrl: { type: String },
        },
        metaInfo () {
            return {
                title: this.title,
                meta: [
                    {description: this.description},
                    {keywords: this.keywords}
                ]
            }
        },
        data () {
            return {
                title:"PPS Healthcare – Improving Your Lifestyle",
                description:"PPS Healthcare – Improving Your Lifestyle",
                keywords:"PPS Healthcare – Improving Your Lifestyle",
                loading:true,
                current:window.location.pathname,
                tpl:"home",
                quanty: ['1', '2', '3', '4','5','6','7','8','9','10'],
                qty:'1',
                products: [
                    {
                        name: ' ',
                        images:false,
                        range_price:false
                    },
                    {
                        name: ' ',
                        images:false,
                        range_price:false
                    },
                    {
                        name: ' ',
                        images:false,
                        range_price:false
                    },
                    {
                        name: ' ',
                        images:false,
                        range_price:false
                    },
                ],
                price:0,
                sku:0,
                descriptions:"",
                images:[],
                page:{
                    images:false,
                    price:0,
                    imgDefault:"aaa"
                },
                imgDefault:"",
                load:{
                    addCart:false,
                },
            }
        },
        methods:{
            init() {
                var u1 = this.current.split('/');
                u1 = u1.pop();
                var u2 = window.location.pathname.split('/');
                u2 = u2.pop();
                if(u1 != u2){
                    this.current = window.location.pathname;
                    //this.loading = true;
                    this.loadPage();
                }
            },
            loadPage(){
                this.$http.get(this.appUrl+"/store/getPage/"+this.$route.params.urlPage).then(response =>{
                    this.loading = false;
                    if(response.data.erro){
                        console.log('404')
                    }else if(response.data.tpl == 'product'){
                        this.tpl = 'product';
                        this.page = response.data.data;
                        this.imgDefault = this.cdnUrl+'/products/'+this.page.images[0].src;
                        this.products = this.page.related;
                        if(this.page.type == 'variable'){
                            this.price = parseFloat(this.page.variables[0].regular_price);
                            this.sku = this.page.variables[0].sku;
                            this.product = this.page.variables[0].id;
                        }else{
                            console.log(this.page.regular_price);
                            this.price = this.page.regular_price;
                            this.sku = this.page.sku;
                        }
                        this.descriptions = this.page.description;
                        this.products = this.page.related;
                        this.images = this.page.images;


                        this.title = this.page.meta_title;
                        this.description = this.page.meta_description;
                        this.keywords = this.page.meta_keywords;
                    }else if(response.data.tpl == 'brand'){
                        this.tpl = 'brand';
                        this.page = response.data.data;
                        this.title = this.page.meta_title;
                        this.description = this.page.meta_description;
                        this.keywords = this.page.meta_keywords;
                    }else{
                        console.log('404')
                    }
                });
            },
            changeVariable(variable){
                var arr = [];
                if(variable == 1){
                    arr = {
                        product:this.page.id,
                        variable:variable,
                        option:this.page.first[1]
                    };

                }
                if(variable == 2){
                    arr = {
                        product:this.page.id,
                        variable:variable,
                        option:this.page.first[1],
                        option2:this.page.first[2]
                    };
                }
                if(variable == 3){
                    arr = {
                        product:this.page.id,
                        variable:variable,
                        option:this.page.first[1],
                        option2:this.page.first[2],
                        option3:this.page.first[3]
                    };
                }
                if(variable == 5){
                    arr = {
                        product:this.page.id,
                        variable:variable,
                        option:this.page.first[1],
                        option2:this.page.first[2],
                        option3:this.page.first[3],
                        option4:this.page.first[4],
                        option5:this.page.first[5]
                    };
                }
                arr = JSON.stringify(arr);
                this.$http.post(this.appUrl+"/store/getVariable",arr).then(response => {
                    var first = Object.values(response.data.first);
                    if(variable == 1){
                        //2
                        if(response.data.options[2].length){
                            this.page.attribute2_values = response.data.options[2];
                            this.page.first[2] = first[1];
                        }else{
                            this.page.first[2] = false;
                            this.page.first[3] = false;
                            this.page.first[4] = false;
                            this.page.first[5] = false;
                        }
                        //3
                        if(response.data.options[3].length){
                            this.page.attribute3_values = response.data.options[3];
                            this.page.first[3] = first[2];
                            if(response.data.options[4].length){
                                this.page.attribute4_values = response.data.options[4];
                                this.page.first[4] = first[3];
                                if(response.data.options[5].length){
                                    this.page.attribute5_values = response.data.options[5];
                                    this.page.first[5] = first[4];
                                }
                            }
                        }else{
                            this.page.first[3] = false;
                            this.page.first[4] = false;
                            this.page.first[5] = false;
                        }
                        //4
                        if(response.data.options[4].length){
                            this.page.attribute4_values = response.data.options[4];
                            this.page.first[4] = first[3];
                        }else{
                            this.page.first[4] = false;
                            this.page.first[5] = false;
                        }
                        //5
                        if(response.data.options[5].length){
                            this.page.attribute5_values = response.data.options[5];
                            this.page.first[5] = first[4];
                        }else{
                            this.page.first[5] = false;
                        }
                    }
                    else if(variable == 2){
                        //3
                        if(response.data.options[3].length){
                            this.page.attribute3_values = response.data.options[3];
                            this.page.first[3] = first[2];
                        }else{
                            this.page.first[3] = false;
                            this.page.first[4] = false;
                            this.page.first[5] = false;
                        }
                        //4
                        if(response.data.options[4].length){
                            this.page.attribute4_values = response.data.options[4];
                            this.page.first[4] = first[3];
                        }else{
                            this.page.first[4] = false;
                            this.page.first[5] = false;
                        }
                        //5
                        if(response.data.options[5].length){
                            this.page.attribute5_values = response.data.options[5];
                            this.page.first[5] = first[4];
                        }else{
                            this.page.first[5] = false;
                        }
                    }
                    else if(variable == 3){
                        //4
                        if(response.data.options[4].length){
                            this.page.attribute4_values = response.data.options[4];
                            this.page.first[4] = first[3];
                        }else{
                            this.page.first[4] = false;
                            this.page.first[5] = false;
                        }
                        //5
                        if(response.data.options[5].length){
                            this.page.attribute5_values = response.data.options[5];
                            this.page.first[5] = first[4];
                        }else{
                            this.page.first[5] = false;
                        }
                    }
                    this.price = response.data.products[0].regular_price;
                    this.sku = response.data.products[0].sku;
                    this.product = response.data.products[0].id;

                    if(response.data.products[0].short_description){
                        this.page.short_description = response.data.products[0].short_description;
                    }
                    if(response.data.products[0].description){
                        this.descriptions = response.data.products[0].description;
                    }
                    if(response.data.products[0].images){
                        this.images = response.data.products[0].images;
                        this.imgDefault = this.cdnUrl+'/products/'+this.images[0].src;
                    }

                });
            },
            changeImage(src){
                this.imgDefault = src;
            },
            addProductCart(id){
                this.load.addCart = true;
                var arr = {
                    token:localStorage.token,
                    id:id,
                    qty:this.qty
                };
                arr = JSON.stringify(arr);
                this.load.addCart = true;
                this.$http.post(this.appUrl+"/store/cart/add",arr).then(response => {
                    if(response){
                        this.load.addCart = false;
                        this.$emit('displayCart', true);
                    }

                });

            },
        },
        mounted(){
            this.$emit('showCart');
            this.loadPage();
            var self = this;
            setInterval(function(){
                    self.init();
                }, 700
            );
        },
        filters:{
            number_format_real(valor){
                return String(parseFloat(valor).toFixed(2));
            },
        }
    }
</script>